import React, { useEffect } from "react";
import { getCreditos } from "../../app/store/actions/creditoActions";
import { getCuentas } from "../../app/store/actions/cuentaActions";
import { connect } from "react-redux";
import PrestamoDashboard from "../consultas/prestamos/principal/PrestamoDashboard";
import LoadingComponent from "../../app/layout/LoadingComponent";
import PropTypes from "prop-types";
import CuentaDashboard from "../consultas/cuentas/principal/CuentaDashboard";

const mapState = (state) => ({
  creditos: state.creditoReducer.creditos,
  loadingCreditos: state.creditoReducer.loadingCreditos,
  cuentas: state.cuentaReducer.cuentas,
  loadingCuentas: state.cuentaReducer.loadingCuentas,
  currentUser: state.auth.currentUser,
});

const actions = {
  getCreditos,
  getCuentas,
};

const InicioPage = ({
  creditos,
  loadingCreditos,
  getCreditos,
  cuentas,
  loadingCuentas,
  getCuentas,
  currentUser,
}) => {
  useEffect(() => {
    if (currentUser?.username) {
      getCreditos();
    }
  }, [getCreditos, currentUser]);

  useEffect(() => {
    if (currentUser?.username) {
      getCuentas();
    }
  }, [getCuentas, currentUser]);

  if (!currentUser) {
    return <LoadingComponent content="Cargando usuario..." />;
  }

  if (loadingCreditos)
    return <LoadingComponent content="Cargando préstamos..." />;
  if (loadingCuentas) return <LoadingComponent content="Cargando cuentas..." />;
  return (
    <>
      <CuentaDashboard cuentas={cuentas} />
      <PrestamoDashboard creditos={creditos} fromInicioPage={true} />
    </>
  );
};

InicioPage.propTypes = {
  creditos: PropTypes.array.isRequired,
  loadingCreditos: PropTypes.bool.isRequired,
  getCreditos: PropTypes.func.isRequired,
  cuentas: PropTypes.array.isRequired,
  loadingCuentas: PropTypes.bool.isRequired,
  getCuentas: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
};

export default connect(mapState, actions)(InicioPage);
